/**
 * Which rave an address belongs to — with no imports and no `import.meta.env`, because the service worker
 * (`offline/sw.ts`, bundled on its own by `swPlugin.ts`) needs the same answer as the page (`tenant.ts`).
 */

/** Never a rave — and never a public page (`isPublicPageHost`). */
export const RESERVED_SUBDOMAINS: ReadonlySet<string> = new Set([
  'www', 'api', 'admin', 'app', 'static', 'cdn', 'mail', 'assets',
  'help', 'support', 'status', 'blog', 'docs', 'dev', 'staging', 'ops',
  // Kept in step with backend/src/config.ts. `media` is the object store's
  // own host; it is never a festival, and neither is `login`.
  'media', 'media-staging', 'login', 'account', 'radm', 'appadm',
  // The staging platform's label — its routes beat production's wildcard.
  'dujitglrkdyya3',
  // The phone apps' permanent install links (worker/installLinks.ts).
  'android', 'apple',
]);


/** The rave's label for `hostname` on `domain`, or null: the bare domain, another site, or a reserved host. */
export function raveOfHost(hostname: string, domain: string): string | null {
  const host = hostname.toLowerCase();
  const d = domain.toLowerCase();
  if (host === d || !host.endsWith(`.${d}`)) return null;
  const prefix = host.slice(0, -(d.length + 1));
  // Only a single label is a tenant, and platform hosts never are.
  if (!prefix || prefix.includes('.') || RESERVED_SUBDOMAINS.has(prefix)) return null;
  return prefix;
}
